import {
    FETCHED_TAG,
    FETCHED_TAGS,
    CREATED_TAG,
    UPDATED_TAG,
    DELETED_TAG,
    FETCHED_VOCABULARIES,
    FETCHED_TAG_PARENTS,
    FETCHED_VOCABULARY_LEVELS,
    SELECTED_VOCABULARY_ID,
    SELECTED_LEVEL,
    SELECTED_PARENT_TAG,
    SELECTED_TAG_NAME,
    SELECTED_TAGOS_ID,
    CLEAR_FORM_FIELDS,
    FETCHED_TAG_TRANSLATIONS,
    FETCHED_TAG_TRANSLATION,
    DELETED_TAG_TRANSLATION,
    EDIT_TEXT_FIELD_INLINE,
    ADD_TEXT_FIELD_INLINE,
    GET_TRANSLATION_FOR_SITE
} from './types';

export function fetchedTags(data, totalPages) {
    return {
        type: FETCHED_TAGS,
        payload: {
            data: data,
            totalPages: totalPages
        }
    }
}

export function fetchedTag(tag) {
    return {
        type: FETCHED_TAG,
        tag
    };
}

export function createdTag(response) {
    return {
        type: CREATED_TAG,
        response
    }
}

export function updatedTag(tag) {
    return {
        type: UPDATED_TAG,
        tag
    }
}

export function deletedTag(tag) {
    return {
        type: DELETED_TAG,
        tag
    }
}

export function fetchedVocabularies(vocabularies) {
    return {
        type: FETCHED_VOCABULARIES,
        vocabularies
    }
}

export function fetchedVocabularyLevels(vocabularyLevels) {
    return {
        type: FETCHED_VOCABULARY_LEVELS,
        vocabularyLevels
    }
}

export function fetchedTagParents(tagParents) {
    return {
        type: FETCHED_TAG_PARENTS,
        tagParents
    }
}

export function selectedVocabularyId(vocabulary) {
    return {
        type: SELECTED_VOCABULARY_ID,
        vocabularyId: vocabulary.id
    }
}

export function selectedLevel(level) {
    return {
        type: SELECTED_LEVEL,
        level: level.id
    }
}

export function selectedParentTag(parentTag) {
    return {
        type: SELECTED_PARENT_TAG,
        parentTagId: parentTag.id
    }
}

export function selectedTagName(tagName) {
    return {
        type: SELECTED_TAG_NAME,
        tagName
    }
}

export function selectedTagosId(tagTagosId) {
    return {
        type: SELECTED_TAGOS_ID,
        tagTagosId
    }
}

export function clearFormFields() {
    return {
        type: CLEAR_FORM_FIELDS,
    }
}

export function fetchedTagTranslations(tagTranslations) {
    return {
        type: FETCHED_TAG_TRANSLATIONS,
        tagTranslations
    }
}

export function fetchedTagTranslation(tagTranslation) {
    return {
        type: FETCHED_TAG_TRANSLATION,
        tagTranslation
    }
}

export function editTextFieldInline(translatedName) {
    return {
        type: EDIT_TEXT_FIELD_INLINE,
        translatedName
    };
}

export function addTextFieldInline(translatedName, siteId) {
    return {
        type: ADD_TEXT_FIELD_INLINE,
        translatedName, siteId
    };
}

export function getTranslationForSite(siteId) {
    return {
        type: GET_TRANSLATION_FOR_SITE,
        siteId
    };
}

export function deletedTagTranslation(tagTranslation) {
    return {
        type: DELETED_TAG_TRANSLATION,
        tagTranslation
    }
}


// WEBPACK FOOTER //
// ./src/containers/tags/actions.js